import React from "react";
import logo from "./beam.png";

export default function PartnerFallback(props) {
  return <img src={logo} alt="" style={props.style} />;
}
